import { render, staticRenderFns } from "./ImagePreview.vue?vue&type=template&id=b0783158&scoped=true"
import script from "./ImagePreview.vue?vue&type=script&lang=ts"
export * from "./ImagePreview.vue?vue&type=script&lang=ts"
import style0 from "./ImagePreview.vue?vue&type=style&index=0&id=b0783158&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0783158",
  null
  
)

export default component.exports